var $ = require('../../modules/$');
module.exports = function defineProperty(it, key, desc){
  return $.setDesc(it, key, desc);
};


//////////////////
// WEBPACK FOOTER
// /~/core-js/library/fn/object/define-property.js
// module id = 1144
// module chunks = 0